/* eslint-disable */
import type {DocumentNode} from 'graphql';
import * as ApolloReactHooks from '@apollo/client/react';
import type {RulesQuery, RulesQueryVariables} from '../types';

export const RulesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Rules"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rules"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"originalTitle"}},{"kind":"Field","name":{"kind":"Name","value":"parentId"}},{"kind":"Field","name":{"kind":"Name","value":"tags"}}]}}]}}]} as unknown as DocumentNode;
/** hook для запроса "Rules" */
export function useRulesQuery(
    baseOptions?: ApolloReactHooks.QueryHookOptions<RulesQuery, RulesQueryVariables>,
) {
    return ApolloReactHooks.useQuery<RulesQuery, RulesQueryVariables>(
        RulesDocument,
        baseOptions ?? ({} as ApolloReactHooks.QueryHookOptions<RulesQuery, RulesQueryVariables>),
    );
}
